<template>
  <div class="notData">
    <i :class="className" v-if="className"></i>
    <p>{{ title }}</p>
  </div>
</template>

<script>
export default {
  props: ["className", "title"],
  data() {
    return {};
  },
  components: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.notData {
  min-height: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  i {
    display: inline-block;
    width: 160px;
    height: 160px;
  }
  i.course {
    background: url(../assets/img/notData/course.png) no-repeat;
    background-size: 160px 160px;
  }
  i.teacher {
    background: url(../assets/img/notData/teacher.png) no-repeat;
    background-size: 160px 160px;
  }
   i.online {
    background: url(../assets/img/notData/online.png) no-repeat;
    background-size: 160px 160px;
  }
  i.training {
    background: url(../assets/img/notData/training.png) no-repeat;
    background-size: 160px 160px;
  }
  i.evaluation {
    background: url(../assets/img/notData/evaluation.png) no-repeat;
    background-size: 160px 160px;
  }
  i.dynamic {
    background: url(../assets/img/notData/dynamic.png) no-repeat;
    background-size: 160px 160px;
  }
  i.work {
    background: url(../assets/img/notData/work.png) no-repeat;
    background-size: 160px 160px;
  }
  i.commodity {
    background: url(../assets/img/notData/commodity.png) no-repeat;
    background-size: 160px 160px;
  }
  i.trip {
    background: url(../assets/img/notData/trip.png) no-repeat;
    background-size: 160px 160px;
  }
  i.active {
    background: url(../assets/img/notData/active.png) no-repeat;
    background-size: 160px 160px;
  }

  p {
    font-size: 14px;
    line-height: 20px;
    color: rgba(134, 135, 138, 1);
    margin-top: 8px;
    font-weight: 300;
  }
}
</style>